<template>
   <footer>
      <div :class="`footer__area ${footerBgTwo ? 'grey-bg-2' : 'footer-bg'}`">
         <div :class="`footer__top ${footerPadding ? 'pt-60' : 'pt-190'} pb-0`">
            <div class="container">
               <div class="row">
                  <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-4 col-sm-6">
                     <div class="footer__widget mb-50">
                        <div class="footer__widget-head mb-22">
                           <div class="footer__logo d-flex align-items-center">
                              <router-link to="/" class="d-flex align-items-center">
                                 <img class="mr-20" :src="`${footerBgTwo
                                    ? require('../../assets/img/logo/logo.png')
                                    : require('../../assets/img/logo/logo-2.png')}`" alt="">
                                 <img :src="`${footerBgTwo
                                    ? require('../../assets/img/logo/logo-ufdpar.png')
                                    : require('../../assets/img/logo/logo-2-ufdpar.png')}`" alt="">
                              </router-link>
                           </div>
                        </div>

                        <div :class="`${footerBgTwo ? 'footer__widget-body-2' : 'footer__widget-body'}`">
                           <p>Acompanhe nossos egressos da UFDPar e participe compartilhando sua trajetória profissional
                              após a graduação.</p>
                        </div>
                     </div>
                  </div>
                  <div class="col-xxl-2 col-xl-2 col-lg-2 col-md-5 col-sm-6"></div>

                  <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-5 col-sm-6">
                     <div class="footer__widget mb-50">
                        <div class="footer__widget-head mb-22">
                           <h3 :class="`${footerBgTwo ? 'footer__widget-title-2' : 'footer__widget-title'}`">Acesso
                              rápido</h3>
                        </div>
                        <div class="footer__widget-body">
                           <div :class="`${footerBgTwo ? 'footer__link-2' : 'footer__link'}`">
                              <ul>
                                 <li><a href="/inicio">Início</a></li>
                                 <!-- <li><a href="/egressos">Egressos</a></li> -->
                                 <li><a href="/questionario">Questionário</a></li>
                                 <li><a href="/oportunidades">Oportunidades</a></li>
                                 <li v-if="adm"><a href="/administrativo">Administrativo</a></li>
                              </ul>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div :class="`${footerBgTwo ? 'footer__bottom footer__bottom-2' : 'footer__bottom'}`">
            <div class="container">
               <div class="row">
                  <div class="col-xxl-12">
                     <div :class="`${footerBgTwo
                        ? 'footer__copyright-2 text-center'
                        : 'footer__copyright text-center'}`">
                        <p>
                           Copyright &copy; {{ currentYear }}. Desenvolvido por
                           <a href="https://ufdpar.edu.br/protic" target="_blank" rel="noopener">
                              PROTIC/UFDPar
                           </a>
                        </p>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </footer>
</template>

<script>
import keycloak from '@/keycloak';
export default {
   name: 'FooterArea',
   data() {
    return {
      adm: false,
      keycloak,
    };
   },
   props: {
      footerBgTwo: String,
      footerPadding: String,
   },
   methods: {
      isAuthenticated() {
      if (this.keycloak?.authenticated) {
        const roles = keycloak.tokenParsed?.resource_access?.["vue-app"]?.roles || [];
        if (roles.includes('administrativo')) {
          this.adm = true;
        }
      }
    },
   },
   computed: {
      currentYear() {
         return new Date().getFullYear();
      }
   },
   mounted() {
    this.isAuthenticated();
  }
};
</script>
